import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiPokemonGeneratorConfig } from '@/data/landingConfig/landingAiPokemonGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiPokemonGenerator } from './schemaObject';

interface Props {}
const AiPokemonGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiPokemonGenerator} />
			<LandingTemplate
				data={landingAiPokemonGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAnimeGenerator()}
			/>
		</>
	);
};

export default AiPokemonGenerator;
